import GetInTouch from "components/getInTouch";
import Reviews from "components/homepage/reviews";
import ServicesGrid from "components/homepage/servicesGrid";
import TranslateAgency from "components/homepage/translateAgency";
import TranslationServices from "components/homepage/translationServices";
import WhatChooseUs from "components/homepage/whyChooseUs";
import LocationBanner from "components/locationBanner";
import SpeceficTranslation from "components/LocationReusableComp/speceficTranslation";
import TrustedTranslation from "components/LocationReusableComp/trustedtranslation";
import React from "react";
import AcadmicInstruction from "../AcadmicInstruction";
import LocalizationMidText from "../localizationMidText";
import WhatsAppComp from "../whatsappComp";
import MarketingTranslationProcess from "./MarketingTranslationProcess";
import NewMarkets from "./NewMarkets";
import TranslationMedium from "./TranslationMedium";

function MarketingTranslation() {
  return (
    <>
      <LocationBanner
        backgroundCol="bg-midBlue"
        title="Marketing Translation Services"
        content="Tomedes' marketing translation services is powered by a network of translators and marketers knowledgeable in over 120 languages and over 950+ languages pairs. We provide solutions for all your marketing documents, websites, and software applications."
        formOrangeHead="Get in touch "
        formWhiteHead="with our Marketing Translation Agency"
      />
      {/* <AcadmicInstruction
        BackgroundCol="bg-darkBlue"
        colorHead="Trusted"
        head="Marketing Translation Services "
        secondHead="by International Brands"
        content="Tomedes is trusted by Fortune 500 companies and small businesses alike. Why not join Google, Amazon, and HP, and put your trust in Tomedes today."
      /> */}
      <TranslateAgency
        head="Marketing Translation Services"
        colorHead="Trusted"
        lastHeadText="by International Brands"
        content="Tomedes is trusted by Fortune 500 companies and small businesses alike. Why not join Google, Amazon, and HP, and put your trust in Tomedes today."
      />
      <LocalizationMidText
        orangeMidText="Marketing"
        content="Translation Services help brands and organizations achieve their global objectives. We provide translations that turn potential into outcomes, delivered on-time by our team of experts."
      />
      <TrustedTranslation
        backgroundCol="bg-darkBlue"
        FirstWhite=""
        headColor="text-lightBlue"
        ColorHead="Professional"
        SecondWhite="Marketing Translation Done by Marketers"
        Content="Marketing translation services are maximized by marketing experts who are knowledgeable within their industry as well as within their native languages, helping brands achieve their global objectives. At Tomedes, we're not just translators, we're SEO experts, software experts, and seasoned marketers."
      />
      <TranslationMedium />
      <NewMarkets />
      <WhatsAppComp
        backgroundCol="bg-midBlue"
        fHead="Looking"
        secondHead=" for a marketing translation company?"
        content="Tomedes hand-picks translators from a global network who are suited for your needs, as well as assigns you with a project manager knowledgeable about the industry. They, as well as the rest of the customer support team, are available 24/7. You can partner with Tomedes, starting right now."
        btn
      />
      <MarketingTranslationProcess />
      <SpeceficTranslation
        FirstOrange="Market"
        SecondWhite="Internationally in over 120 Languages and 950+ Language Pairs"
        headColor="text-orange"
        Content="At Tomedes, you can market internationally in over 120 languages and 950+ language pairs, which means that you can extend your reach to a global audience and potentially increase your leads, all through translating in a variety of languages suited for you."
        backgroundCol="bg-midBlue"
      />
      <ServicesGrid
        heading="Marketing Translation for Every Industry"
        backgroundCol="bg-darkBlue"
        colorComp=""
        details="Tomedes translation company provides marketing translation services for every industry, including luxury, fast moving consumer goods, and other specialized industries. Whichever industry you’re in, we can accommodate you."
        contactUs
      />
      <WhatChooseUs backgroundCol="bg-midBlue" />
      <Reviews backgroundCol="bg-darkBlue" />
      <TranslationServices backgroundCol="bg-midBlue" />
      <GetInTouch />
    </>
  );
}

export default MarketingTranslation;
